export default __webpack_public_path__ + "static/media/DiceStyles.db684041.mp4";